<template>
  <div class="softwareList-page">
    <div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    <div class="all-container">
      <img src="../../assets/img/softwareList/banner_bg.png" alt="" class="banner_bg">
      <div class="center-container">
        <div class="nav-search-container">
          <div class="search-container">
            <input type="text" class="search-inp" placeholder="请输入搜索关键字">
            <div class="search-btn">
              <img src="../../assets/img/common/sousuo.png" alt="">
            </div>
          </div>
          <ul class="nav-list-container drop-down-container">
            <div class="nav-all-data-container">
              <span>
                所有分类
              </span>
            </div>
            <li class="nav-item-container">
              <div class="item-dropdown">
                <span class="dropdown-link-text">
                  产品
                </span>
                <img :src="( isHover == 1 ? down_true : down_false)" alt="" class="dropdown-status-img">
              </div>
              <div class="box">
                <ul class="item-dropdown-menu">
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'bby_iot_platform' )">全厂物联平台</a>
                  </li>
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'intelligentWorkOrder' )">智能工单</a>
                  </li>
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'industrial_internet' )">工业互联网</a>
                  </li>
                </ul>
              </div>
            </li>
            <li class="nav-item-container">
              <div class="item-dropdown">
                <span class="dropdown-link-text">
                  解决方案
                </span>
                <img :src="( isHover == 2 ? down_true : down_false)" alt="" class="dropdown-status-img">
              </div>
              <div  class="box">
                <ul class="item-dropdown-menu">
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'jijiagong' )">解决方案一</a>
                  </li>
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'industrial_interconnection2' )">解决方案二</a>
                  </li>
                </ul>
              </div>
            </li>
            <li class="nav-item-container">
              <div class="item-dropdown">
                <span class="dropdown-link-text">
                  优秀案例
                </span>
                <img :src="( isHover == 3 ? down_true : down_false)" alt="" class="dropdown-status-img">
              </div>
              <div class="box">
                <ul class="item-dropdown-menu">
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'lithiumBatteryMES' )">锂电池MES系统</a>
                  </li>
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'factoryFireControl' )">厂区消防</a>
                  </li>
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'viewChemicalIndustry' )">视觉化工智慧平台</a>
                  </li>
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'intelligentWorkOrderERP' )">智能工单ERP</a>
                  </li>
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'farming' )">智慧农业</a>
                  </li>
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'microseismic' )">微震监测平台</a>
                  </li>
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'mingyue' )">明月眼镜WMS</a>
                  </li>
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'huanjing' )">环保大数据IOT</a>
                  </li>
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'intelligentIndustry2' )">智能工业</a>
                  </li>
                </ul>
              </div>
            </li>
            <li class="nav-item-container">
              <div class="item-dropdown">
                <span class="dropdown-link-text">
                  工业app
                </span>
                <img :src="( isHover == 4 ? down_true : down_false)" alt="" class="dropdown-status-img">
              </div>
              <div class="box">
                <ul class="item-dropdown-menu">
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'industrialIntelligenceUnion' )">数字乡村</a>
                  </li>
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'chintMeter' )">正泰电表</a>
                  </li>
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'intelligentMotor' )">智能电机</a>
                  </li>
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'apartmentMeter' )">公寓电表</a>
                  </li>
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'smartCampus' )">智慧校园</a>
                  </li>
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'EEEManagement' )">能效管理</a>
                  </li>
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'jijiagongApp' )">机加工互联</a>
                  </li>
                  <li class="dropdown-item-menu">
                    <a href="javascript:;" @click="jump( 'beautiful' )">美容仪器</a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
          <ul class="nav-list-container">
            <div class="nav-all-data-container">
              <span>
                全部
              </span>
            </div>
            <li class="nav-item-container" @click="jump( 'bby_iot_platform' )">
              <span class="nav-item-name">
                全厂物联平台
              </span>
            </li>
            <li class="nav-item-container" @click="jump( 'intelligentWorkOrder' )">
              <span class="nav-item-name">
                智能工单
              </span>
            </li>
            <li class="nav-item-container" @click="jump( 'viewChemicalIndustry' )">
              <span class="nav-item-name">
                视觉化工智慧平台
              </span>
            </li>
            <li class="nav-item-container" @click="jump( 'intelligentIndustry2' )">
              <span class="nav-item-name">
                智能工业
              </span>
            </li>
            <li class="nav-item-container" @click="jump( 'industrialIntelligenceUnion' )">
              <span class="nav-item-name">
                数字乡村
              </span>
            </li>
            <li class="nav-item-container" @click="jump( 'industrial_internet' )">
              <span class="nav-item-name">
                工业互联网
              </span>
            </li>
          </ul>
        </div>
        <!-- 特别推荐 -->
        <div class="special-recommendation-container">
          <div class="special-recommendation-left-container">
            <img src="../../assets/img/softwareList/recommendation_product_banner.png" alt="" class="recommendation-product-banner">
            <div class="product-summary-container">
              <p class="recommendation-product-title">百倍云-工业App</p>
              <p class="recommendation-product-describe">服务只为更好的明天</p>
            </div>
          </div>
          <div class="special-recommendation-right-container">
            <div class="special-recommendation-right-top-container">
              <ul class="recommendation-product-trait-list-container">
                <li class="trait-item-container">
                  <img src="../../assets/img/softwareList/trait_default1.png" alt="" class="trait-item-img">
                  <p class="trait-item-title">部署灵活</p>
                  <p class="trait-item-describe">接入周期短，内外网可安装混合云、私有云可部署</p>
                </li>
                <li class="trait-item-container">
                  <img src="../../assets/img/softwareList/trait_default2.png" alt="" class="trait-item-img">
                  <p class="trait-item-title">接入安全</p>
                  <p class="trait-item-describe">多协议终端设备接入管理，安全的数据传输和访问控制</p>
                </li>
                <li class="trait-item-container">
                  <img src="../../assets/img/softwareList/trait_default3.png" alt="" class="trait-item-img">
                  <p class="trait-item-title">分析数据</p>
                  <p class="trait-item-describe">工业大数据分析、故障诊断、预测性维护</p>
                </li>
                <li class="trait-item-container">
                  <img src="../../assets/img/softwareList/trait_default4.png" alt="" class="trait-item-img">
                  <p class="trait-item-title">应用升级</p>
                  <p class="trait-item-describe">上层应用升级、多系统融合、集成应用</p>
                </li>
              </ul>
            </div>
            <div class="special-recommendation-right-bottom-container">
              <p class="title">百倍云头条</p>
              <ul class="recommendation-product-content-list-container">
                <li class="content-item-container" v-for="( item , index ) in AllInfoData" :key="index">
                  <a class="jumpLink" :href="'http://www.数字乡村.com/forum/view/zixundetails.html?type=0&idd='+ item.objectId +''" target="_blank">
                    <span class="first-title">
                      {{ item.title }}
                    </span> 
                    <span class="describe">
                      {{ item.content }}
                    </span>
                  </a>
                </li>
                <!-- <li class="content-item-container">
                  <span class="first-title">
                    强化学习(十六) 深度确定性策略梯度(DDPG)
                  </span> 
                  <span class="describe">
                    从DDPG这个名字看，它是由D（Deep）+D（Deterministic ）+ PG(Policy或框...
                  </span>
                </li>
                <li class="content-item-container">
                  <span class="first-title">
                    IOT，亿万狂想曲
                  </span> 
                  <span class="describe">
                    只是这个未来太过遥远，以至于在过去数年，听众已经厌烦了这样的想象，对教程或框架用图像
                  </span>
                </li> -->
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 产品展示 -->
      <div class="product-exhibition-container">
        <div class="popular-product-container">
          <div class="center-container">
            <div class="type-title-container">
              <p class="type-title">热门</p>
            </div>
            <ul class="popular-product-list-container">
              <li class="popular-product-item-container" @click="jump( 'viewChemicalIndustry' )">
                <img src="../../assets/img/softwareList/remen_product1.png" alt="" class="item-img">
                <p class="product-item-name">视觉化工智慧平台</p>
                <img src="../../assets/img/softwareList/see_you_more.png" @click="jump( 'viewChemicalIndustry' )" alt="" class="see-details-btn">
              </li>
              <li class="popular-product-item-container" @click="jump( 'bby_iot_platform' )">
                <img src="../../assets/img/softwareList/remen_product2.png" alt="" class="item-img">
                <p class="product-item-name">全厂物联平台</p>
                <img src="../../assets/img/softwareList/see_you_more.png" @click="jump( 'bby_iot_platform' )" alt="" class="see-details-btn">
              </li>
              <li class="popular-product-item-container" @click="jump( 'microseismic' )">
                <img src="../../assets/img/softwareList/remen_product3.png" alt="" class="item-img">
                <p class="product-item-name">微震监测平台</p>
                <img src="../../assets/img/softwareList/see_you_more.png" @click="jump( 'microseismic' )" alt="" class="see-details-btn">
              </li>
            </ul>
          </div>
        </div>
        <div class="center-container">
          <!-- 主要产品展示 -->
          <div class="main-product-exhibition-list-container" v-for="( item , key ) in softwareList" :key="key">
            <div class="product-list-top-container">
              <div class="type-title-container">
                <p class="type-title">
                  {{ item.title }}
                </p>
              </div>
              <div class="operation-container" @click="flod( item , item.flag , key )" onselectstart="return false">
                <span class="text">
                  {{ item.flag ? '收起' : '展开' }}
                </span>
                <img :src="( item.flag ? shousuo : zhankai )" alt="" class="operation-status-img">
              </div>
            </div>
            <ul class="product-list-container" v-show=" item.flag ">
              <li class="product-item-container" v-for="( childItem , index ) in item.listData" :key="index"  @click="jump( childItem.linkAddress )">
                <img :src="childItem.imgCopy" alt="" class="product-item-img">
                <p class="product-item-name">{{ childItem.title }}</p>
              </li>
            </ul>
          </div>  
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'
import softwareList from "@/static/softwareList"
import axios from 'axios'
export default {
  name: 'softwareList',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {
      softwareList: [],
      zhankai: require( '../../assets/img/softwareList/zhankai.png' ),
      shousuo: require( '../../assets/img/softwareList/shousuo.png' ),
      down_true: require( '../../assets/img/softwareList/down_true.png' ),
      down_false: require( '../../assets/img/softwareList/down_false.png' ),
      imgUrlArr:[ 
        require( '../../assets/img/softwareList/list_default1.png' ),
        require( '../../assets/img/softwareList/list_default2.png' ),
        require( '../../assets/img/softwareList/list_default3.png' ),
        require( '../../assets/img/softwareList/list_default4.png' ),
        require( '../../assets/img/softwareList/list_default5.png' ),
        require( '../../assets/img/softwareList/list_default6.png' ),
        require( '../../assets/img/softwareList/list_default7.png' ),
        require( '../../assets/img/softwareList/list_default8.png' ),
        require( '../../assets/img/softwareList/list_default9.png' ),
        require( '../../assets/img/softwareList/list_default10.png' ),
        require( '../../assets/img/softwareList/list_default11.png' ),
        require( '../../assets/img/softwareList/list_default12.png' ),
        require( '../../assets/img/softwareList/list_default13.png' ),
        require( '../../assets/img/softwareList/list_default14.png' ),
      ],
      isHover: false,
      AllInfoData: [], // 资讯数据
    }
  },
  created () {
    let index = 0
    for( let i = 0 , len = softwareList.length ; i < len ; i++ ){
      softwareList[i].flag = true
      for( let j = 0 , leng = softwareList[i].listData.length ; j < leng ; j++ ){
        softwareList[i].listData[j].imgCopy = this.imgUrlArr[index]
        index++
      }
    }
    this.softwareList = softwareList

    this.init();
  }, 
  mounted() {
    let that = this
    $(document).on("mouseover",".nav-item-container",function(){
      $(this).find(".item-dropdown-menu").show()
      let index = $(this).index()
      that.isHover = index
    })
    $(document).on("mouseout",".nav-item-container",function(){
      $(this).find(".item-dropdown-menu").hide()
      that.isHover = false
    })
  },
  methods: {
    init(){
      this.listAllInformation()
    },
    flod( item , itemFlag , key ){
      item.flag = !itemFlag
    },
    jump( pathName , id ){
      if( id ){
        this.$router.push({
          name: pathName,
          query: {
            id: id,
          }
        })
      }else{
        this.$router.push({
          name: pathName,
        })
      }
    },
    listAllInformation(){ // 获取资讯
      axios.get('http://115.29.203.1:8045/robot3' + "/web/information/listAllInformation?&pageNum=" + 1 + "&pageSize=" + 3, 
        {
          params: {
            pageNum: 1,
            pageSize: 3,
            token: '',
          },
        }).then( ( res ) =>{
          if( res.code === 200 ){
            let data = res.data

            this.AllInfoData = data
          }
        }).catch( ( err ) =>{
          console.log( err );
        })
    },
  }
}
</script>
<style lang="scss">

</style>
